var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shequ"},[_c('img',{attrs:{"src":require("../../assets/katong.jpg"),"alt":""}}),_c('div',{staticClass:"zhezhao_bai"}),_c('div',{staticClass:"text"},[_c('p',[_vm._v("皮皮社区")]),_vm._v(" 年轻人的交友社区，一个温馨的角落，分享你的碎语人生，随时随地记录生活点滴！ "),_c('p',[_vm._v("敬请期待！")])])])
}]

export { render, staticRenderFns }